











































































































import {Vue, Prop, Component} from 'vue-property-decorator';
import { noAbc, nextInput } from "@/modules/budget/monitoring/input-forms/common/formaters"


type InputModelType = 1 | 2
@Component({
    filters: {
        totalCBC(value: any[]) {
            let sum = 0;
            if (value) {
                for (const gr of value) {
                    for (const r of gr.children) {
                        sum += r.value
                    }
                }
            }
            return parseFloat(Math.abs(sum).toFixed(3));
        }
    }
})
export default class ReasonInput extends Vue {
    @Prop({
        required: true,
        default: []
    })
    private reasonsFull!: any[];

    private reasonsTreeList: any = {
        reason_type_1: [],
        reason_type_3: [],
        reason_type_2: []
    };

    @Prop({
        required: true,
        default: []
    })
    private cbcList!: any[];
    @Prop({
        required: true,
        default: []
    })
    private inputModelType!: InputModelType;
    @Prop({
        required: true,
        default: {}
    })
    flk_keys!:any
    @Prop({
        required: true,
        default: {}
    })
    flk_func!:any


    private get sortedCbcList() {
        return this.cbcList.sort((a: any, b: any) => a['ppr_key'].localeCompare(b['ppr_key']));
    }

    private currentCBC: any = null;

    private get sortedProjectList() {
        if (this.sortedCbcList.length && this.currentCBC) {
            return this.currentCBC.child_list.sort((a: any, b: any) => a['expense_code'].localeCompare(b['expense_code']));
        }
        return [];
    }

    private currentProject: any = null;

    private project_flk: any = {}
    inputModel: any = {}
    inputModelList = [
        {
            input_model: 1,
            name_ru: 'Ожидаемое неисполнение плана на год',
            name_kk: 'Бір жылдық жоспардың күтілетін орындалмауы',
            name_en: 'Expected non-execution of the annual plan'
        },
        {
            input_model: 2,
            name_ru: 'Неосвоение за отчетный период',
            name_kk: 'Есепті кезеңге игерілмеу',
            name_en: 'Under-execution for the reporting period'
        }
    ]


    private async created() {
        const that = this;
        this.inputModel = this.inputModelList.find(v => v.input_model === this.inputModelType);
        if (this.cbcList.length > 0) {
            this.currentCBC = this.sortedCbcList[0]
        }
        for (const key of Object.keys(this.flk_keys)) {
            Object.defineProperty(that.project_flk, key, {
                get: function () {
                    return that.total(that.reasonsTreeList[key]) !== Math.abs(parseFloat(that.currentProject[that.flk_keys[key]].toFixed(3)))
                }
            })
        }
        this.$watch('currentProject', (n, o) => {

            if (o !== null) {
                if (o.chagedReasons) {
                    that.onSave(o)
                }
            }


            that.updateReasonsTree()

        })
        this.$watch('inputModel', (n, o) => {
            that.updateReasonsTree()
        }, {deep: true})
        this.$watch('currentCBC', (n, o) => {
            if (this.currentProject !== null) {
                if (this.currentProject.chagedReasons) {
                    that.onSave(this.currentProject)
                }
            }
            if (this.sortedProjectList.length) {
                this.currentProject = this.sortedProjectList[0]
            }
        })
        if (this.sortedProjectList.length) {
            this.currentProject = this.sortedProjectList[0]
        }
    }

    private async updateReasonsTree() {
        if (this.currentProject) {
            const dict: any = {
                reason_type_1: 2,
                reason_type_2: 2,
                reason_type_3: 1,
            }
            for (const key of this.inputKeys) {
                const reasonsFull: any[] = this.reasonsFull.map((r) => ({...r}))
                for (const r of reasonsFull) {
                    if (r.id in this.currentProject[key]) {
                        r.value = Math.abs(this.currentProject[key][r.id])
                    } else {
                        r.value = 0
                    }
                }
                this.reasonsTreeList[key] = this.createReasonsTreeFlat(dict[key], reasonsFull)
            }
        }
    }

    private createReasonsTreeFlat(obaz_plat: any = 1, reasonsFull: any[] = []) {
        // obaz_plat: 1 obaz 2 plat
        const that = this;
        const dict_reasons: any = {}
        const gr_key = obaz_plat === 1 ? 'ob' : 'pl'
        const id_key = `gr_${gr_key}_id`
        const gr_name_key = `gr_${gr_key}_name_`
        for (const r of reasonsFull) {
            if (
                (obaz_plat === 1 && ![10, 11, 12].includes(r[id_key]))
                || (obaz_plat === 2 && ![1, 2, 3, 5, 6, 7, 8].includes(r[id_key]))
            ) {
                continue
            }
            if (!dict_reasons[r[id_key]]) {
                const grobj = {children: [], open: false, ...r}
                Object.defineProperty(grobj, 'label', {
                    get() {
                        return grobj[`${gr_name_key}${that.$i18n.locale}`]
                    }
                })
                Object.defineProperty(grobj, 'value', {
                    get: function () {
                        let sum = 0
                        for (const ch of grobj.children) {
                            sum += ch.value
                        }
                        return sum
                    }
                })
                dict_reasons[r[id_key]] = grobj
            }
            const robj: any = {...r}
            Object.defineProperty(robj, 'label', {
                get() {
                    return robj[`name_${that.$i18n.locale}`]
                }
            })
            dict_reasons[r[id_key]].children.push(robj)

        }
        return Object.values(dict_reasons)
    }


    private onfocusInputModel() {
        if (this.currentProject !== null) {
            if (this.currentProject.chagedReasons) {
                this.onSave(this.currentProject)
            }
        }
    }
    private get inputKeys() {
        if (this.inputModel?.input_model === 2) {
            return ['reason_type_1', 'reason_type_3']
        } else {
            return ['reason_type_2']
        }
    }
    private get flk() {
        let flk = false
        for (const key of this.inputKeys) {
            flk = flk || this.flk_func(this.currentProject, key)
        }
        return flk
    }


    private total(value: any[]) {
        let sum = 0;
        if (value) {
            for (const gr of value) {
                for (const r of gr.children) {
                    sum += r.value
                }
            }
        }
        return parseFloat(Math.abs(sum).toFixed(3));
    }

    private onClearReasons() {
        this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.reports.app_9.reason_input.confirm_delete').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    for (const key of ['reason_type_1', 'reason_type_2', 'reason_type_3']) {
                        for (const gr of this.reasonsTreeList[key]) {
                            for (const r of gr.children) {
                                if (r.value !== 0) {
                                    r.value = 0
                                    this.currentProject[key][r.id] = 0
                                    this.currentProject.chagedReasons = true
                                }
                            }
                        }
                    }
                }
            })
            .catch(error => {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.reports.app_9.save_error'), error.toString());
            });
    }

    private onBack() {
        if (this.currentProject?.chagedReasons) {
            this.onSave(this.currentProject);
        }
        this.$emit('onBack')
    }
    private async onNext() {
        this.onSave(this.currentProject)
        const cbcIdx = this.sortedCbcList.findIndex((v:any) => v.ppr_key === this.currentCBC.ppr_key);
        const isFlk = (v:any) => {
            let flk = false
            for (const key of this.inputKeys) {
                flk = flk || this.flk_func(v, key)
            }
            return flk
        }
        let success = true
        let i = cbcIdx;
        while (i < this.sortedCbcList.length) {
            const currentProjectIndex = this.sortedProjectList.findIndex((v:any) => parseInt(v.expense_code) === parseInt(this.currentProject.expense_code))
            let newIndex = currentProjectIndex;
            newIndex = this.sortedProjectList.findIndex((v:any) => v.expense_code > this.currentProject.expense_code && isFlk(v))
            let switch_next = true
            if (newIndex > -1) {
                switch_next = false
            }
            if (newIndex < 0 || currentProjectIndex >= this.sortedProjectList.length - 1) {
                newIndex = 0;
                if (i === this.sortedCbcList.length - 1) {
                    this.currentCBC = this.sortedCbcList[0]
                }
            }
            this.currentProject = this.sortedProjectList[newIndex]
            if (!switch_next) {
                break;
            }
            i++
            if (i < this.sortedCbcList.length) {
                this.currentCBC = await this.sortedCbcList[i]
            }
        }
        for (const cbc of this.sortedCbcList) {
            success = success && cbc.child_list.every((v: any) => !isFlk(v))
        }
        if (success) {
            this.currentCBC = this.sortedCbcList[0]
            this.makeToast('success',
                this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.massage'),
                this.$t('modules.budget_execution_monitoring.reports.app_9.reason_input.warn_success_reasons')
            )
        }

    }

    private onSave(currentProject:any = null) {
        if (currentProject === null) {
            currentProject = this.currentProject
        }
        for (const key of this.inputKeys) {
            currentProject[key] = {}
            for (const gr of this.reasonsTreeList[key]) {

                for (const r of gr.children) {
                    if (r.value !== 0) {
                        if (currentProject[this.flk_keys[key]] < 0) {
                            currentProject[key][r.id] = -Math.abs(r.value)
                        } else {
                            currentProject[key][r.id] = r.value
                        }
                    }
                }
            }
        }
        if (currentProject && currentProject.hasOwnProperty('chagedReasons')) {
            currentProject.hasChanges = true
            delete currentProject.chagedReasons;
        }
    }
    private onSaveAndClose() {
        this.onSave(this.currentProject)
        this.onBack()
    }
    // -----------------
    private noAbc: Function = noAbc
    private nextInput: Function = nextInput

    private getNextInputIndx(prgIdx: number, pprIdx: number, spfIndx: number, chldIndx: number | null) {
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }
    onChange(el: any, key: string) {
        const value = el[key]
        if (value) {
            el[key] = parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, ''))
        } else {
            el[key] = 0;
        }
    }
    private inputFixed(item: any, field: any, value: any, digit: any) {
        if (value) {
            this.currentProject.chagedReasons = true
            this.$set(item, field, parseFloat(Math.abs(parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, ''))).toFixed(digit)));
        } else {
            this.currentProject.chagedReasons = true
            this.$set(item, field, 0);
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
}
